export const Uri = `${process.env.REACT_APP_URL}`;
export const Headers = {
  "x-hasura-admin-secret": `${process.env.REACT_APP_HASURA_SECRET}`,
};
export const UploadUrl = `${process.env.REACT_APP_UPLOAD_URL}`;
